import { compareBundlesByVersionDesc, fetchFirmwareBundleFilenames, makeCdnUrl } from "motion-master-client";

import { Component } from "react";

import { brandId } from "./brand";
import Icon from "./icons";

class FirmwareBundles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bundles: null,
    };
  }

  componentDidMount() {
    fetchFirmwareBundleFilenames().then((bundles) => {
      bundles.sort(compareBundlesByVersionDesc);
      this.setState({ bundles });
    });
  }

  render() {
    let list;

    if (this.state.bundles === null) {
      list = <div>Loading...</div>;
    } else {
      list = this.state.bundles.map((item) => {
        const link = makeCdnUrl(`/brands/${brandId}/bundles/firmwares/${item}`);
        const text = item;
        return (
          <a
            href={link}
            title={`Download ${item}`}
            key={item}
            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
          >
            <span>
              {Icon.boxes}
              &nbsp;
              {text}
            </span>
            {Icon.download}
          </a>
        );
      });
    }

    return <div className="list-group list-group-flush">{list}</div>;
  }
}

export default FirmwareBundles;
